<template>
  <div
    :class="`
      flex
      align--${props.align}
      justify--${props.justify}
      gap--${props.gap}
      direction--${props.direction}
      wrap--${props.wrap}
  `">
    <slot></slot>
  </div>
</template>

<script lang="ts" setup>
const props = withDefaults(
  defineProps<{
    align?: 'center' | 'start' | 'end' | 'stretch';
    justify?: 'start' | 'end' | 'center' | 'between' | 'around';
    direction?: 'row' | 'column';
    wrap?: 'wrap' | 'nowrap';
    gap?: 0 | 1 | 2 | 3 | 4 | 5 | 6;
  }>(),
  {
    align: 'start',
    justify: 'start',
    direction: 'row',
    wrap: 'nowrap',
    gap: 0,
  }
);
</script>
<style scoped>
.flex {
  display: flex;
  width: 100%;
}

.align--start {
  align-items: flex-start;
}

.align--end {
  align-items: flex-end;
}

.align--center {
  align-items: center;
}

.align--stretch {
  align-items: stretch;
}

.justify--start {
  justify-content: flex-start;
}

.justify--end {
  justify-content: flex-end;
}

.justify--center {
  justify-content: center;
}

.justify--between {
  justify-content: space-between;
}

.justify--around {
  justify-content: space-around;
}

.direction--row {
  flex-direction: row;
}

.direction--column {
  flex-direction: column;
}

.gap--0 {
  gap: 0;
}

.gap--1 {
  gap: var(--md-spacing-4);
}

.gap--2 {
  gap: var(--md-spacing-8);
}

.gap--3 {
  gap: var(--md-spacing-16);
}

.gap--4 {
  gap: var(--md-spacing-24);
}

.gap--5 {
  gap: var(--md-spacing-32);
}

.gap--6 {
  gap: var(--md-spacing-40);
}

.wrap--wrap {
  flex-wrap: wrap;
}

.wrap--nowrap {
  flex-wrap: nowrap;
}
</style>
